export const fieldsName = {
    vehicleTaxiUsage: 'vehicle-taxiUsage',
    vehicleRequiredTO: 'vehicle-requiredTO',
    vehicleVehicleType: 'vehicle-vehicleType',
    vehicleRegisterCity: 'vehicle-registerCity',
    vehicleBrand: 'vehicle-brand',
    vehicleOwnerPartyType: 'vehicle-ownerPartyType',
    vehicleConstructionYear: 'vehicle-constructionYear',
    vehicleOwnerBirthYear: 'vehicle-ownerBirthYear',
    vehicleNextToDate: 'vehicle-nextToDate',
    startDate: 'startDate'
}